import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_staging/69d7ce8fa7495700144c960a/fastfoodcrypto/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69d7ce8fa7495700144c960a/fastfoodcrypto/src/styles/tailwind.css");
